module.exports = __webpack_public_path__ + "static/media/tube_placed.205814ea.svg";